import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private httpClient: HttpClient) {
  }

  public getAll(limite: number, desplazamiento: number, fechaInicio: NgbDateStruct | null, fechaFin: NgbDateStruct | null, rangoDias: string | null, estado: string | null): Observable<any> {

    let params = new HttpParams();

    if (rangoDias == 'RANGO' || rangoDias == 'NINGUNO') {
      rangoDias = null;
    }

    if (estado == 'TODOS') {
      estado = null;
    }

    if (rangoDias != null) {
      params = params.append('rangoDias', rangoDias);
    }

    if (fechaInicio != null) {
      params = params.append('fechaInicio', fechaInicio.toString() );
    }

    if (fechaFin != null) {
      params = params.append('fechaFin', fechaFin.toString() );
    }

    if (estado != null) {
      params = params.append('estado', estado);
    }

    if (desplazamiento != null) {
      params = params.append('desplazamiento', desplazamiento.toString());
    }
    if (limite != null) {
      params = params.append('limite', limite.toString());
    }


    return this.httpClient.get<any>( environment.api_tienda + '/tiendas/' + environment.idStore + '/facturasPaginable',
      {params}
    );
  }

  pagarFactura(idFactura: number): Observable<any> {
    const factura = {idFactura: idFactura};
    return this.httpClient.post(
      environment.api_tienda + '/tiendas/' + environment.idStore + '/facturas/' + idFactura + '/pagos',
      factura, {responseType: 'text'}
    );
  }


}
